<template>
  <scout-tab-panel
    :is-active="isActive"
    title="送信候補"
    name="review"
    :link="link"
    data-test="panel-review"
    tooltip="貴社がスカウトやいいねの送信を検討している会員を一時保存することができます。"
  />
</template>

<script>
import ScoutTabPanel from '@/components/atoms/ScoutTabPanel'

export default {
  components: { ScoutTabPanel },
  computed: {
    isActive () {
      return this.$route.path.includes('/under_review')
    },
    link () {
      return { name: 'scoutUnderReview' }
    }
  }
}

</script>
